
import generalMixin from '~/mixins/generalMixin'

export default {
  mixins: [
    generalMixin
  ],

  props: {
    countriesOptions: {
      type: Array,
      default () {
        return []
      },
      required: true
    }
  },

  data () {
    return {
      form: {
        search: null,
        exp_level: [],
        role: null,
        duration: [],
        pay_min: null,
        pay_max: null,
        type: [],
        workload: [],
        country: null
      },

      exp_options: [
        { value: 'junior', text: this.$t('levels.junior.title') },
        { value: 'medior', text: this.$t('levels.medior.title') },
        { value: 'senior', text: this.$t('levels.senior.title') }
      ],
      role_options: [
        { value: null, text: this.$t('no_selection') },
        { value: 'admin', text: this.$t('roles.admin.title') },
        { value: 'developer', text: this.$t('roles.developer.title') },
        { value: 'devops', text: this.$t('roles.devops.title') },
        { value: 'consultant', text: this.$t('roles.consultant.title') },
        { value: 'analyst', text: this.$t('roles.analyst.title') },
        { value: 'owner', text: this.$t('roles.owner.title') },
        { value: 'pm', text: this.$t('roles.pm.title') },
        { value: 'sa', text: this.$t('roles.sa.title') },
        { value: 'ta', text: this.$t('roles.ta.title') },
        { value: 'marketer', text: this.$t('roles.marketer.title') }
      ],
      project_length_options: [
        { value: 'quick', text: this.$t('project_length_options.quick') },
        { value: 'short', text: this.$t('project_length_options.short') },
        { value: 'medium', text: this.$t('project_length_options.medium') },
        { value: 'long', text: this.$t('project_length_options.long') },
        { value: 'permanent', text: this.$t('project_length_options.permanent') }
      ],
      type_options: [
        { value: 'ongoing', text: this.$t('project_types.ongoing') },
        { value: 'new', text: this.$t('project_types.new') },
        { value: 'legacy', text: this.$t('project_types.legacy') }
      ],
      workload_options: [
        { value: '10', text: this.$t('workload_options.hours_10') },
        { value: '20', text: this.$t('workload_options.hours_20') },
        { value: '30', text: this.$t('workload_options.hours_30') },
        { value: '40', text: this.$t('workload_options.hours_40') }
      ]
    }
  },

  created () {
    this.populateQuery()
  },

  methods: {
    populateQuery () {
      const params = this.urlGetParams(!!this.$route.params && !!this.$route.params.filter ? this.$route.params.filter : {})

      this.form = {
        search: params.search ?? null,
        exp_level: Array.isArray(params.exp_level) ? params.exp_level : (!!params.exp_level ? [params.exp_level] : []),
        role: params.role ?? null,
        duration: Array.isArray(params.duration) ? params.duration : (!!params.duration ? [params.duration] : []),
        pay_min: params.pay_min ?? null,
        pay_max: params.pay_max ?? null,
        type: Array.isArray(params.type) ? params.type : (!!params.type ? [params.type] : []),
        workload: Array.isArray(params.workload) ? params.workload : (!!params.workload ? [params.workload] : []),
        country: params.country ?? null
      }
    },

    applyFilter () {
      if (!!this.form.pay_max && this.form.pay_max < this.form.pay_min) {
        const max = this.form.pay_max
        this.form.pay_max = this.form.pay_min
        this.form.pay_min = max
      }
      const filter = this.urlBuildParams(this.form)

      if (!!filter) {
        this.$router.push(this.localePath({ name: 'jobs-filter', params: { filter } }))
      } else {
        this.$router.push(this.localePath({ name: 'jobs' }))
      }
    },

    searchClick () {
      const filter = this.urlBuildParams({
        search: this.form.search
      })

      if (!!filter) {
        this.$router.push(this.localePath({ name: 'jobs-filter', params: { filter } }))
      } else {
        this.$router.push(this.localePath({ name: 'jobs' }))
      }
    }
  }
}
